import React from 'react';
import styled from 'styled-components';
import {
  breakpointSizes,
  minBreakpointQuery,
  standardColours,
  greyColours,
  brandColours,
  brandFonts,
  fontWeights,
  fontSize,
  fluidFontSize,
  headingStyles,
  standardTransition,
} from '../../styles';
import eyeIcon from '../../images/eye-icon.bg.svg';

export const StyledHtmlContent = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
    ${brandFonts.secondary};
    line-height: 1.1;

    ${minBreakpointQuery.small`
      margin-top: 10px;
      margin-bottom: 10px;
    `}

    ${minBreakpointQuery.large`
      margin-top: 12px;
      margin-bottom: 12px;
    `}
  }

  h2 {
    ${headingStyles(true)};
  }

  h3 {
    ${fluidFontSize(
      '22px',
      '28px',
      breakpointSizes.tiny,
      breakpointSizes.xxlarge,
    )};
  }

  h4 {
    ${fluidFontSize(
      '20px',
      '26px',
      breakpointSizes.tiny,
      breakpointSizes.xxlarge,
    )};
  }

  h5 {
    ${fluidFontSize(
      '18px',
      '22px',
      breakpointSizes.tiny,
      breakpointSizes.xxlarge,
    )};
  }

  h6 {
    ${fluidFontSize(
      '16px',
      '20px',
      breakpointSizes.tiny,
      breakpointSizes.xxlarge,
    )};
  }

  p {
    margin-bottom: 15px;
    line-height: 1.7;

    ${minBreakpointQuery.small`
      margin-bottom: 20px;
      ${fontSize(18)};
    `}

    ${minBreakpointQuery.large`
      margin-bottom: 25px;
    `}

    &:last-child {
      margin-bottom: 0;
    }

    b {
      font-weight: ${fontWeights.regular};
    }
  }

  blockquote {
    font-style: italic;
    margin-bottom: 15px;
    line-height: 1.7;
  }

  a {
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: ${standardTransition('color')};

    &:hover {
      color: ${brandColours.quinary};
    }
  }

  ul,
  ol {
    margin-bottom: 15px;

    ${minBreakpointQuery.small`
      margin-bottom: 20px;
    `}

    ${minBreakpointQuery.large`
      margin-bottom: 25px;
    `}

    &:last-child {
      margin-bottom: 0;
    }

    li {
      margin-top: 6px;
      line-height: 1.7;

      ${minBreakpointQuery.small`
        margin-top: 8px;
        ${fontSize(18)};
      `}

      ${minBreakpointQuery.large`
        margin-top: 10px;
      `}

      &:first-child {
        margin-top: 0;
      }
    }
  }

  ul {
    li {
      padding-left: 26px;
      background: url(${eyeIcon}) no-repeat 0 9px / 16px 12px;
    }
  }

  ol {
    list-style-type: decimal;

    li {
      margin-left: 16px;
    }
  }

  img {
    margin: 25px 0;
    height: auto !important;

    ${minBreakpointQuery.small`
      margin-top: 30px;
      margin-bottom: 30px;
    `}

    ${minBreakpointQuery.large`
      margin-top: 35px;
      margin-bottom: 35px;
    `}
  }

  table {
    margin: 0 auto 25px auto;
    background-color: ${standardColours.white};
    border: 1px solid ${greyColours.lightGrey};

    th,
    td {
      padding: 10px;
      text-align: center;
    }

    th {
      color: ${brandColours};
      font-weight: ${fontWeights.bold};
    }

    tbody td {
      border-top: 1px solid ${greyColours.lightGrey};
    }
  }
`;

export const HtmlContent = ({ html, children, ...props }) =>
  html ? (
    <StyledHtmlContent dangerouslySetInnerHTML={{ __html: html }} {...props} />
  ) : children ? (
    <StyledHtmlContent {...props}>{children}</StyledHtmlContent>
  ) : (
    ''
  );
